
        var result = require("!!../../../../node_modules/css-loader/index.js!./flag-ticket-treshold-count.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/flag-ticket-treshold-count/flag-ticket-treshold-count.component.css
// module id = 727
// module chunks = 0